/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-15",
    versionChannel: "nightly",
    buildDate: "2025-04-15T00:07:01.300Z",
    commitHash: "6a2c1df7e28f4c301674f091d9318597a94db86c",
};
